import { render, staticRenderFns } from "./r-logo.vue?vue&type=template&id=dcb711d0"
import script from "./r-logo.vue?vue&type=script&lang=js"
export * from "./r-logo.vue?vue&type=script&lang=js"
import style0 from "./r-logo.vue?vue&type=style&index=0&id=dcb711d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports